// src/fontawesome.js

import { library } from '@fortawesome/fontawesome-svg-core';
import { faEdit, faTimes, faBell, faFilter, faEyeSlash, faChartBar, faTable, faCheckCircle, faSpinner, faTimesCircle, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faEdit, faTimes, faBell, faFilter, faEyeSlash, faChartBar, faTable, faCheckCircle, faSpinner, faTimesCircle, faArrowRight);

export { FontAwesomeIcon };
